import React, { useState } from "react";
import useRevealOnIntersect from "../hooks/useRevealOnIntersect";
import { useScrollToTopOnMount } from "../hooks/useScrollToTop";
import "./NewsletterPage.css";

const BENEFITS = [
  {
    icon: "🔐",
    title: "Security Insights",
    desc: "Practical guidance on CCTV, AI surveillance, and infrastructure hardening — written for decision-makers.",
  },
  {
    icon: "📡",
    title: "Network & IoT Updates",
    desc: "Coverage of enterprise Wi-Fi, IoT deployments, and connectivity best practices from real projects.",
  },
  {
    icon: "🖥️",
    title: "IT Infrastructure Notes",
    desc: "Server setups, backup strategies, and data centre trends — distilled into actionable takeaways.",
  },
  {
    icon: "📦",
    title: "Project Highlights",
    desc: "Behind-the-scenes updates on Nexite rollouts, case studies, and supply chain insights.",
  },
];

function NewsletterPage() {
  useScrollToTopOnMount();
  useRevealOnIntersect(".nl-pg-reveal", { threshold: 0.15 });

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) {
      setStatus("Please enter a valid email address.");
      return;
    }
    const subject = encodeURIComponent("Nexite Newsletter Signup");
    const body = encodeURIComponent(
      `Please add this email to the Nexite newsletter list:\n\n${email.trim()}`
    );
    window.location.href = `mailto:info.nexite@gmail.com?subject=${subject}&body=${body}`;
    setStatus("Your email app has been opened — complete the request to sign up.");
  }

  return (
    <main className="nl-pg">
      {/* ── Hero ── */}
      <section className="nl-pg-hero">
        <div className="nl-pg-hero-bg" aria-hidden="true">
          <span className="nl-blob b1" />
          <span className="nl-blob b2" />
        </div>
        <div className="nl-pg-hero-inner">
          <span className="nl-pg-pill nl-pg-reveal" style={{ "--d": "0ms" }}>
            Newsletter
          </span>
          <h1 className="nl-pg-heading nl-pg-reveal" style={{ "--d": "60ms" }}>
            Stay ahead with <br />
            <span className="nl-pg-accent">Nexite intelligence</span>
          </h1>
          <p className="nl-pg-sub nl-pg-reveal" style={{ "--d": "120ms" }}>
            Low-volume, high-value updates for technology leaders and delivery teams. No noise — only
            what matters.
          </p>

          <form
            className="nl-pg-form nl-pg-reveal"
            style={{ "--d": "180ms" }}
            onSubmit={handleSubmit}
          >
            <input
              type="email"
              className="nl-pg-input"
              placeholder="Enter your work email"
              required
              aria-label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="nl-pg-btn">
              <span className="nl-shine" aria-hidden="true" />
              Subscribe
            </button>
          </form>
          {status && <p className="nl-pg-status">{status}</p>}

          <p className="nl-pg-privacy nl-pg-reveal" style={{ "--d": "220ms" }}>
            No spam. Unsubscribe anytime.
          </p>
        </div>
      </section>

      {/* ── Benefits ── */}
      <section className="nl-pg-benefits">
        <div className="nl-pg-benefits-inner">
          <h2 className="nl-pg-section-title nl-pg-reveal" style={{ "--d": "0ms" }}>
            What you'll receive
          </h2>
          <div className="nl-pg-cards">
            {BENEFITS.map((b, i) => (
              <div
                key={b.title}
                className="nl-pg-card nl-pg-reveal"
                style={{ "--d": `${i * 80}ms` }}
              >
                <span className="nl-pg-card-icon">{b.icon}</span>
                <h3 className="nl-pg-card-title">{b.title}</h3>
                <p className="nl-pg-card-desc">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Bottom CTA ── */}
      <section className="nl-pg-cta">
        <div className="nl-pg-cta-inner nl-pg-reveal" style={{ "--d": "0ms" }}>
          <h2 className="nl-pg-cta-title">Ready to stay informed?</h2>
          <p className="nl-pg-cta-sub">
            Join professionals who rely on Nexite insights for better technology decisions.
          </p>
          <form className="nl-pg-form nl-pg-form-cta" onSubmit={handleSubmit}>
            <input
              type="email"
              className="nl-pg-input"
              placeholder="Enter your work email"
              required
              aria-label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="nl-pg-btn">
              <span className="nl-shine" aria-hidden="true" />
              Subscribe
            </button>
          </form>
          {status && <p className="nl-pg-status">{status}</p>}
        </div>
      </section>
    </main>
  );
}

export default NewsletterPage;
